"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stdTransformDependencies = void 0;

var _dependenciesSqrtGenerated = require("./dependenciesSqrt.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _dependenciesVarianceGenerated = require("./dependenciesVariance.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var stdTransformDependencies = {
  sqrtDependencies: _dependenciesSqrtGenerated.sqrtDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  varianceDependencies: _dependenciesVarianceGenerated.varianceDependencies,
  createStdTransform: _factoriesAny.createStdTransform
};
exports.stdTransformDependencies = stdTransformDependencies;